// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step-advanced-settings-modal .modal-body .form-group.VueTables__search{margin:auto auto 15px}", ""]);
// Exports
module.exports = exports;
